import style from './AdminNote.module.scss';
import MainLayout from '@/components/MainLayout';
import AdminSidebar from '@/components/AdminSidebar';
import SelectClinician from '@/components/SelectClinician';

export default function AdminNote() {
  return (
    <MainLayout
      sideBarContent={<AdminSidebar sideBarContent={null} />}
      mainContent={
        <>
          <div className="flex border-b border-solid border-gray-300">
            <div className="flex flex-grow basis-1/2 justify-between items-center">
              <form>
                <div className={style.select__styles}>
                  <SelectClinician />
                </div>
              </form>
            </div>
          </div>
          <p className={style.content__placeholder}>
            <span className={style.content__placeholder__title}>No clinician selected</span>
            <span className={style.content__placeholder__text}>
              Select a clinician above to load their schedule.
            </span>
          </p>
        </>
      }
    />
  );
}
